import input from './input'
import success from './success'

const sign = {
  path: 'sign/:id',
  component: resolve => require(['../../../../../pages/domain/sbs/training/sign'], resolve),
  children: [
    input,
    success
  ]
}

export default sign



// WEBPACK FOOTER //
// ./src/router/domain/sbs/training/sign/index.js